import { LangService } from "@app/services/lang.service"
import {
	Component,
	OnInit,
	Input,
	EventEmitter,
	Output,
	SimpleChange,
} from "@angular/core"
import { patientColors } from "@app/definitions/types"
import { environment } from "@env/environment"
import { StoreService } from "@app/services/store.service"

@Component({
	selector: "app-banner",
	template: `
		@if (!isLoading && person) {
			<div
				class="patient-banner pointer"
				(click)="onClick.emit()"
			>
				<div
					class="img-overlay-gradient"
					[style.background]="personBanner.bg"
				>
					<span>
						{{ person?.name }}
						@if (type === "patient" && addIdNumber) {
              <span style="font-size: 18px;  margin: 8px 30px 0;">
							{{ person?.id_number }}
							{{ person?.age }}</span>
						}
					</span>
				</div>
				<div
					class="patient-banner-background"
					[style.background-image]="
						personBanner.pic ? 'url(' + personBanner.pic + ')' : null
					"
				></div>
			</div>
		}
	`,
})
export class BannerComponent {
	//handles the person(patient/contact/payor) banner
	@Input() isLoading: boolean = false //is in loading state
	@Input() person: any = null //the object data (of type patient/contact/payor)
	@Input() type: "patient" | "contact" | "payor" | "user" = "patient" //type of object, used for config purposes
	personBanner: any = { pic: null, bg: null } //contains the banner info itself
	@Output() onClick = new EventEmitter() //informs of a click on the banner
	addIdNumber: boolean = false

	constructor(
		private lang: LangService,
		public store: StoreService
	) {}

	ngOnChanges(changes: SimpleChange) {
		//handles change in input vars
		if (changes["person"]) {
			//if a person object has change - call loadBG
			this.loadBG()
		}
	}

	loadBG() {
		this.addIdNumber =
			this.store.getCliniqDataOrExit()?.id_number_on_patient_banner === "yes"
		if (!this.person) {
			return
		} //person is empty - return
		let isEng = !this.lang.isRtl //used to flip the gradient
		const bg =
			(this.type == "patient"
				? patientColors[this.person.id % patientColors.length]
				: this.lang.getConfigVal("color." + this.type)) || "" //if object has color data use it, otherwise try config
		let personBg = bg.replace("#", "") //remove the # from the bg string
		this.personBanner.pic =
			environment.serverUrl + "/images/backgrounds/" + personBg + ".png" //actual pic path on server
		// var isFileExist = fileExists(patientImageUrl, patientBg);
		this.personBanner.bg = isEng
			? "linear-gradient(90deg, #" +
				personBg +
				" 0%, #" +
				personBg +
				" 20%, #" +
				personBg +
				" 30%, #" +
				personBg +
				"00 100%)"
			: "linear-gradient(90deg, #" +
				personBg +
				"00 0%, #" +
				personBg +
				" 70%, #" +
				personBg +
				" 80%, #" +
				personBg +
				" 100%)" //gradient css for background of banner
	}
}

//implement contact,payor, check if all display correctly
